import React from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { getInstitutionAllApi } from '../../../api/institution';
import FormHelperText from '@material-ui/core/FormHelperText';

class InstitutionNativeSelect extends React.Component {
  state = {
    age: '',
    name: 'hai',
    insList : [],
    institutionsId:0,
  };

  handleChange = name => event => {
    this.setState({[name]: event.target.value});
    this.props.onChange(event.target.value);
  };

  
  componentDidMount =  async() =>{
    const insList = await getInstitutionAllApi();
    this.setState({insList:insList});
  }
  


  render() {
    const {insList} = this.state;
    const {institutionsErrorText,institutionId} = this.props;

    
    return (
      <div className="row">
        <div className="col-lg-12 col-sm-12 col-12">
          <FormControl className="w-100 mb-2">
            <InputLabel htmlFor="age-native-simple">Kurum / Üniversite</InputLabel>
            <Select
              native
              error={institutionsErrorText==="" ? false : true}
              value={institutionId}
              onChange={this.handleChange('institutionId')}
              input={<Input id="age-native-simple"/>}
            >
              <option value=""/>
          
              {insList.map(item => {
                    return (
                        <option key={item.institutionId} value={item.institutionId}>{item.name}</option>
                    );
               })}
            </Select>
            <FormHelperText style={{color:"#f44336"}}> {institutionsErrorText}</FormHelperText>

          </FormControl>
        </div>
      
      </div>
    );
  }
}

export default InstitutionNativeSelect;